import { Component, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { DebtorService } from '../_services/index';
import { ParameterData } from '../_helpers/index';
import { Debtor } from '../_models/index';
import { debtordocumenttype, debtorStatus, debtorPhonePrefix, DocumentService } from '../_enums/debtordocumenttype';

@Component({
    selector: 'customeredit',
    templateUrl: './customeredit.component.html'
})
export class CustomerEditComponent implements OnInit {

    public customer_public_id: string;

    public debtorForm: FormGroup;
    public debPublicID: any;
    customerPuplic_key: any;
    inputPrefixPhone: any;
    inputPhoneNo: any;
    isEmailEditControlDisabled = false;
    isalertVisiable = false;
    isalertExistVisiable = false;
    isalertErrorVisible = false;
    editDebtorName: any;
    statusresult: any;
    ddldbdocumenttype: any[];
    ddldebtorStatus: any[];
    ddldebtorPhonePrefix: any;
    debname: any;

    constructor(private parameterData: ParameterData, private debtorService: DebtorService
        , private _fb: FormBuilder, private router: Router,
        private route: ActivatedRoute
        , private documentType: debtordocumenttype
        , private _debtorStatus: debtorStatus
        , private _debtorPhonePrefix: debtorPhonePrefix,
        private documentService: DocumentService
    ) {
        this.isEmailEditControlDisabled = false;
        this.isalertVisiable = false;
        this.ddldebtorStatus = _debtorStatus.Status;
        this.InitialSetup();
    }

    InitialSetup() {
        this.debtorForm = this._fb.group({
            id: new FormControl(0),
            external_id: new FormControl(""),
            name: new FormControl("", [Validators.required, Validators.maxLength(50), Validators.pattern("[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+")]),
            email: new FormControl("", [Validators.required, Validators.email]),
            phone: new FormControl("", Validators.required),
            document_id: new FormControl("", [Validators.required, Validators.pattern("^[0-9]*$")]),
            document_type: new FormControl("Seleccione", [Validators.required]),
            status: new FormControl("Seleccione"),
            address: this._fb.group({
                id: new FormControl(0),
                street: new FormControl('', Validators.pattern("[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+")),
                county: new FormControl('', Validators.pattern("[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+")),
                city: new FormControl('', Validators.pattern("[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+")),
                state: new FormControl('', Validators.pattern("[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+")),
                created: new FormControl("0"),
                zip: new FormControl('" "')
            }),
            creditor: this._fb.group({
                public_id: new FormControl(this.customer_public_id)
            })
        });
    }





    ngOnInit() {
        let country = localStorage.getItem('country')
        this.ddldebtorPhonePrefix = this.documentService.getPrefixByIsoAlpha2(country);
        this.ddldbdocumenttype = this.documentService.getDocumentsByIsoAlpha2(country);

        let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
        if (browserStorage1 == null) {
            let browserStorage = localStorage.getItem('companyId');
            if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
                this.router.navigate(['/home']);
            }
            else {
                this.customer_public_id = localStorage.getItem('companyId');
            }
        }
        else {
            this.customer_public_id = localStorage.getItem('subcompanyId');
        }
        let params: any = this.route.snapshot.params;
        this.debPublicID = params.id;

        if (this.debPublicID != null) {
            this.isEmailEditControlDisabled = true;
            this.debtorService.getIndDebtorDetails(this.debPublicID).subscribe((debtor: Debtor) => {
                let statusvalue = this.ddldebtorStatus.find(x => x.value === debtor.status);
                this.inputPrefixPhone = this.documentService.getCountryCode(debtor.phone);
                this.inputPhoneNo = this.documentService.getPhoneNumberOnly(debtor.phone);
                this.editDebtorName = debtor.name;
                let doctypevalue = this.ddldbdocumenttype.find(x => x.short_name === debtor.document_type);
                setTimeout(() => {
                    this.debtorForm = this._fb.group({
                        id: new FormControl(debtor.id),
                        external_id: new FormControl(debtor.external_id),
                        name: new FormControl(debtor.name, [Validators.maxLength(250), Validators.pattern("[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+")]),
                        email: new FormControl(debtor.email),
                        phone: new FormControl(this.documentService.getPhoneNumberOnly(debtor.phone)),
                        document_id: new FormControl(debtor.document_id),
                        document_type: new FormControl(doctypevalue.short_name),
                        status: new FormControl(statusvalue.value),
                        address: this._fb.group({
                            id: new FormControl(debtor.address.id),
                            street: new FormControl(debtor.address.street, Validators.pattern("[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+")),
                            county: new FormControl(debtor.address.county, Validators.pattern("[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+")),
                            city: new FormControl(debtor.address.city, Validators.pattern("[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+")),
                            state: new FormControl(debtor.address.state, Validators.pattern("[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+")),
                            created: new FormControl(debtor.address.created),
                            zip: new FormControl(debtor.address.zip)
                        })
                    });
                    if (doctypevalue.short_name === 'OTHER') {
                        this.debtorForm.controls.document_id.setValidators([Validators.pattern("^[a-zA-Z0-9 \'\-]+$")])
                    } else {
                        this.debtorForm.controls.document_id.setValidators([Validators.required, Validators.pattern("^[0-9]*$")])
                    }
                }, 500)

            })
        }

    }//end


    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            if (!((charCode >= 37 && charCode <= 42) || charCode == 45 || charCode == 46 || charCode == 35 || charCode == 32)) {
                return false;
            }
        }
        return true;

    }

    documentTypeChange(documentType) {
        if (documentType === 'OTHER') {
            this.debtorForm.controls.document_id.setValue("");
            this.debtorForm.controls.document_id.setValidators([Validators.pattern("^[a-zA-Z0-9 \'\-]+$")])
        }
        else {
            this.debtorForm.controls.document_id.setValue("");
            this.debtorForm.controls.document_id.setValidators([Validators.required, Validators.pattern("^[0-9]*$")])
        }
    }

    @HostListener('window:keydown', ['$event'])
    keyEvent(event: KeyboardEvent) {

        if (event.ctrlKey && event.keyCode == 83) {
            if (this.debtorForm.valid) {


                event.preventDefault();
                this.onsubmit(this.debtorForm);
            }
            else {
                event.preventDefault();
            }

        }
    }


    onsubmit({ value }: { value: Debtor }) {
        if (!(this.inputPrefixPhone == undefined || this.inputPrefixPhone == null)) {
            value.phone = this.inputPrefixPhone + this.inputPhoneNo;
        }
        
        if (value.id === null) {
            value.id = 0;
        }
        if (value.id != 0) {
            this.debtorService.updateDebtor(this.debPublicID, value)
                .subscribe((result) => {
                    if (result.status == "200") {
                        if (result.body.Error == "500") {
                            this.statusresult = result.body.Description;
                            this.isalertExistVisiable = true;
                            this.isalertVisiable = false;
                            this.isalertErrorVisible = false;
                        }
                        else if (result.body.Error == "400") {
                            this.statusresult = "Error actualizando información, revisar datos o reintente denuevo"
                            this.isalertErrorVisible = true;
                            this.isalertExistVisiable = false;
                            this.isalertVisiable = false;
                        }
                        else
                            if (result.body.email == value.email && result.body.external_id == value.external_id) {

                                this.router.navigate([`/customers/${result.body.public_id}/view`]);
                                this.isalertExistVisiable = false;
                                this.isalertVisiable = true;
                                this.isalertErrorVisible = false;
                            }
                            else {
                                this.statusresult = "Cliente con ese email o código ya existe";
                                this.debPublicID = result.body.public_id;
                                this.debname = result.body.name;
                                this.isalertExistVisiable = true;
                                this.isalertVisiable = false;
                                this.isalertErrorVisible = false;
                            }
                    }
                }, error => {
                    
                    this.statusresult = "Error actualizando información, revisar datos o reintente denuevo";
                    this.isalertExistVisiable = false;
                    this.isalertVisiable = false;
                    this.isalertErrorVisible = true;
                    console.log('Failed while trying to update the Debtor Details.' + error);
                });

        }

    }

}//end
